import convertToPlainText from "@cclib/functions/quill/convertToPlainText.js";

function stripQuillTags(text) {
    return text.replace(/<\/?(p|span|em|strong|u)\b[^>]*>/gi, "");
}

export function getLongestPlainTextLineLength(event) {
    const plainText = convertToPlainText(event?.text || "");

    return plainText
        .split("\n")
        .reduce((longest, line) => Math.max(longest, line.length), 0);
}

// Convert an Event's xPos into a 1-based left-edge character column.
export function resolveEventXPosition(event, displayWidth) {
    const xPos = event?.xPos;

    if (typeof xPos === "number") {
        return xPos;
    }

    const longestLineLength = getLongestPlainTextLineLength(event);

    switch (xPos) {
        case "start":
            return 1;
        case "center":
            return Math.floor((displayWidth - longestLineLength) / 2) + 1;
        case "end":
            return displayWidth - longestLineLength + 1;
        default:
            return 1;
    }
}

// Clamp a numeric left-edge column back to "start"/"end" once it reaches a limit.
export function normalizeEventXPosition(event, xPos, displayWidth) {
    if (typeof xPos !== "number") {
        return xPos;
    }

    const longestLineLength = getLongestPlainTextLineLength(event);
    const rightmostColumn = displayWidth - longestLineLength + 1;

    if (xPos <= 1) {
        return "start";
    }

    if (xPos >= rightmostColumn) {
        return "end";
    }

    return xPos;
}

export function getEventLineCount(event) {
    return Math.max(
        1,
        (event?.text || "").split("</p>").filter((textLine) => {
            return stripQuillTags(textLine).trim() !== "";
        }).length,
    );
}

export function getLowestVisibleYPosition(event, displayHeight = 15) {
    return Math.max(1, displayHeight - getEventLineCount(event) + 1);
}

export function normalizeEventYPosition(event, yPos, displayHeight = 15) {
    if (typeof yPos !== "number") return yPos;

    return Math.min(yPos, getLowestVisibleYPosition(event, displayHeight));
}

export function resolvePreviewVerticalJustify(event, yPos, displayHeight = 15) {
    if (typeof yPos === "number") {
        const normalizedYPos = normalizeEventYPosition(event, yPos, displayHeight);
        const yPercentage = normalizedYPos / displayHeight;

        if (yPercentage <= 0.2) return "start";
        if (yPercentage >= 0.5) return "end";

        return "center";
    }

    switch (yPos) {
        case "start":
        case "top":
            return "start";
        case "center":
        case "middle":
            return "center";
        case "end":
        case "bottom":
        default:
            return "end";
    }
}
